var _path, _circle, _circle2, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgValidateUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 85,
    viewBox: "0 0 60 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 30C60 46.5685 38.75 76.25 30 85C21.25 76.25 0 46.5685 0 30C0 13.4315 13.4315 0 30 0C46.5685 0 60 13.4315 60 30Z",
    fill: "url(#paint0_linear_67_8372)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 25,
    fill: "url(#paint1_linear_67_8372)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 23,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6937 41.3451H18.9528C18.5199 41.3451 18.1017 41.1184 17.8632 40.7562C17.6394 40.4175 17.6011 40.0082 17.7601 39.6283C17.8249 39.4752 17.8868 39.3191 17.9486 39.163C18.1047 38.7714 18.2666 38.368 18.4669 37.9851C20.9258 33.2823 26.1174 30.8323 31.3885 31.8865C32.7254 32.1545 34.0241 32.664 35.2432 33.3972C35.3963 33.4885 35.5671 33.5503 35.7144 33.5621C36.0942 33.6004 36.4299 33.3677 36.5507 32.9908C36.6714 32.6109 36.5242 32.237 36.1678 32.0161C34.242 30.8294 32.1247 30.155 29.8778 30.0107C27.6516 29.8664 25.549 30.2227 23.632 31.0679C19.9687 32.6846 17.448 35.432 16.1435 39.2337C15.9609 39.7697 15.9521 40.3262 16.1199 40.8916C16.4939 42.152 17.6482 43.0001 18.9911 43.0001C20.9258 43.0001 22.8634 43.0001 24.7981 43.0001H27.2864H33.12C33.9946 43.0001 34.8722 43.0001 35.7467 43.0001C35.9882 43.0001 36.2061 42.9088 36.3651 42.7439C36.5212 42.5849 36.6007 42.3669 36.5948 42.1343C36.5801 41.672 36.2032 41.3363 35.7026 41.3363L35.6937 41.3451Z",
    fill: "#2C2C2C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9916 28.2821H29.0004C30.8998 28.2821 32.6873 27.54 34.033 26.1943C35.3817 24.8456 36.1267 23.0551 36.1297 21.1499C36.1297 19.2417 35.3906 17.4454 34.0419 16.0937C32.6961 14.745 30.9057 14 28.9975 14C25.0692 14 21.8653 17.198 21.8535 21.1293C21.8476 23.0257 22.5867 24.8161 23.9354 26.1707C25.29 27.5312 27.0863 28.2791 28.9945 28.2821H28.9916ZM28.9916 15.6608H29.0004C32.0188 15.6667 34.4718 18.1256 34.4718 21.141C34.4718 24.1594 32.0159 26.6183 28.9975 26.6183C27.531 26.6183 26.1528 26.0441 25.1163 25.0046C24.0797 23.9651 23.5114 22.5899 23.5143 21.1293C23.5232 18.1109 25.9791 15.6608 28.9945 15.6608H28.9916Z",
    fill: "#2C2C2C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7477 39.799C36.5416 39.799 36.3325 39.7194 36.1764 39.5604L31.3558 34.7398C31.0407 34.4248 31.0407 33.9124 31.3558 33.5943C31.6709 33.2792 32.1862 33.2792 32.5013 33.5943L36.7506 37.8436L47.0308 27.5635C47.3459 27.2484 47.8612 27.2484 48.1763 27.5635C48.4914 27.8786 48.4914 28.3909 48.1763 28.709L37.3219 39.5634C37.1629 39.7224 36.9568 39.8019 36.7506 39.8019L36.7477 39.799Z",
    fill: "#2C2C2C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_67_8372",
    x1: 30,
    y1: 0,
    x2: 30,
    y2: 85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6B4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736FF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_67_8372",
    x1: 30,
    y1: 5,
    x2: 30,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#736FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B4FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidateUserIcon);
export default __webpack_public_path__ + "static/media/validateUserIcon.c185bb6b88b9c9e011d9e0bd240c4f0e.svg";
export { ForwardRef as ReactComponent };